import { render, staticRenderFns } from "./AliPayControl.vue?vue&type=template&id=479aa965&scoped=true&"
import script from "./AliPayControl.vue?vue&type=script&lang=js&"
export * from "./AliPayControl.vue?vue&type=script&lang=js&"
import style0 from "./AliPayControl.vue?vue&type=style&index=0&id=479aa965&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479aa965",
  null
  
)

export default component.exports